module.exports = __webpack_public_path__ + "static/media/oeko-tex.d276269b.png";